import { createContext, useContext, useState, useEffect } from 'react'

const ShowSqlContext = createContext(null)

export function ShowSqlProvider({ children }) {
  const [showSqlEnabled, setShowSqlEnabled] = useState(
    () => localStorage.getItem('sd-show-sql') === 'true'
  )

  useEffect(() => {
    localStorage.setItem('sd-show-sql', String(showSqlEnabled))
  }, [showSqlEnabled])

  function toggle() { setShowSqlEnabled(v => !v) }

  return (
    <ShowSqlContext.Provider value={{ showSqlEnabled, setShowSqlEnabled, toggle }}>
      {children}
    </ShowSqlContext.Provider>
  )
}

export function useShowSqlSetting() {
  const ctx = useContext(ShowSqlContext)
  if (!ctx) throw new Error('useShowSqlSetting must be used within ShowSqlProvider')
  return ctx
}
